(function () {
  // Neutralize the Seal Subscriptions widget inside the donation forms.
  // We do NOT remove Seal's markup (Seal re-inserts it and the two scripts fight).
  // Instead: keep it hidden, and rename/disable its inputs so its radios are no
  // longer in the same 'selling_plan' group as our Monthly / One-time toggle.
  var KEEP_INPUTS = ['form_type', 'utf8', 'quantity', 'product-id', 'section-id', 'id'];
  var KEEP_CLASSES = ['dn-cta-wrap', 'dn-trust', 'dn-editor-note', 'dh-cta', 'dh-err', 'dh-trust', 'dh-small'];
  function isOurs(el) {
    if (el.tagName === 'FIELDSET') return true;
    if (el.tagName === 'INPUT') return KEEP_INPUTS.indexOf(el.getAttribute('name')) !== -1;
    for (var i = 0; i < KEEP_CLASSES.length; i++) { if (el.classList.contains(KEEP_CLASSES[i])) return true; }
    return false;
  }
  function inOurFreq(el) { return !!el.closest('.dn-freq, .dh-freq'); }
  function neutralize(form) {
    form.querySelectorAll('[name="selling_plan"]').forEach(function (el) {
      if (inOurFreq(el)) return;
      el.setAttribute('name', 'bp_seal_off');
      el.disabled = true;
    });
    Array.prototype.slice.call(form.children).forEach(function (el) {
      if (!isOurs(el) && el.style.display !== 'none') el.style.setProperty('display', 'none', 'important');
    });
    var wrap = form.querySelector('.dn-cta-wrap');
    if (wrap) {
      Array.prototype.slice.call(wrap.children).forEach(function (el) {
        if (!el.classList.contains('dn-cta') && !el.classList.contains('dn-error') && el.style.display !== 'none') el.style.setProperty('display', 'none', 'important');
      });
    }
    // If Seal knocked our toggle off, restore its default choice.
    var ours = form.querySelectorAll('.dn-freq input[name="selling_plan"], .dh-freq input[name="selling_plan"]');
    if (ours.length) {
      var anyChecked = Array.prototype.some.call(ours, function (r) { return r.checked; });
      if (!anyChecked) {
        var def = Array.prototype.filter.call(ours, function (r) { return r.defaultChecked; })[0] || ours[0];
        def.checked = true;
        def.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
  function watchForms() {
    document.querySelectorAll('form.dn-form, form.dh-form').forEach(function (form) {
      neutralize(form);
      if (form.dataset.bpWatched) return;
      form.dataset.bpWatched = '1';
      if ('MutationObserver' in window) {
        // childList only: our own changes are attribute/style changes, so this never loops.
        new MutationObserver(function () { neutralize(form); }).observe(form, { childList: true, subtree: true });
      }
    });
  }
  watchForms();
  document.addEventListener('DOMContentLoaded', watchForms);
  window.addEventListener('load', watchForms);

  // Cart drawer upsell toggle
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-bp-upsell]');
    if (!sw) return;
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    var on = sw.getAttribute('aria-checked') === 'true';
    sw.setAttribute('aria-busy', 'true');
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    var url, body;
    if (on && sw.dataset.lineKey) {
      url = (window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js';
      body = { id: sw.dataset.lineKey, quantity: 0, sections: sections.join(','), sections_url: location.pathname };
    } else {
      url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      body = { items: [{ id: Number(sw.dataset.variantId), quantity: 1 }], sections: sections.join(','), sections_url: location.pathname };
    }
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
          drawer.renderContents(state);
        } else {
          location.reload();
        }
      })
      .catch(function () { location.reload(); });
  });

  // Scroll-to-top button
  var top = document.querySelector('.bp-top');
  if (top) {
    var onScroll = function () { top.classList.toggle('is-visible', window.scrollY > 400); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  // Section reveal on scroll
  var els = document.querySelectorAll('.bp-reveal');
  if ('IntersectionObserver' in window && els.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { io.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.add('is-in'); });
  }
})();
